import { Wallet, AlertTriangle, Plus } from "lucide-react";
import { Card, CardContent } from "@/modules/shared/ui/components/card";
import { Button } from "@/modules/shared/ui/components/button";
import type { WalletDto } from "../../dtos/wallet.dto";

interface WalletBalanceCardProps {
  wallet: WalletDto;
  onTopUp: () => void;
}

export function WalletBalanceCard({ wallet, onTopUp }: WalletBalanceCardProps) {
  const isLow = wallet.balance <= wallet.lowBalanceThreshold;

  return (
    <Card className="rounded-2xl border border-border shadow-lg bg-card">
      <CardContent className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <Wallet className="h-6 w-6 text-primary" />
          </div>
          <div>
            <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
              Wallet Balance
            </p>
            <p className="text-3xl font-bold text-foreground">
              {wallet.currency} {wallet.balance.toFixed(2)}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          {isLow && (
            <div className="flex items-center gap-1.5 rounded-full bg-amber-50 dark:bg-amber-400/10 px-3 py-1.5 text-amber-700 dark:text-amber-300">
              <AlertTriangle className="h-4 w-4" />
              <span className="text-xs font-medium">Low balance</span>
            </div>
          )}
          <Button
            onClick={onTopUp}
            className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold"
          >
            <Plus className="h-4 w-4" />
            Top Up
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
